export var PlanSelectionVariations = /*#__PURE__*/function (PlanSelectionVariations) {
  PlanSelectionVariations["PLAN_SELECTION"] = "PLAN_SELECTION";
  PlanSelectionVariations["CSP_UPSELL"] = "CSP_UPSELL";
  return PlanSelectionVariations;
}({});

// raw content response from Contentful

export var IneligibleUpgradeProducts = /*#__PURE__*/function (IneligibleUpgradeProducts) {
  IneligibleUpgradeProducts["MATH"] = "1652";
  IneligibleUpgradeProducts["EASYBIB"] = "3329";
  return IneligibleUpgradeProducts;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/interfaces.js
// module id = 874
// module chunks = 11